import { agent } from '@shared/services/agent';

export type PairedDeviceType = 'KIOSK' | 'SIGNAGE';

export interface VisitorCheckinCodeView {
  id: number;
  code: string;
  officeId: number;
  officeLabel: string;
  label: string | null;
  createdAt: string;
  expiresAt: string;
  revoked: boolean;
  activeDeviceCount: number;
  deviceType: PairedDeviceType;
}

export interface VisitorCheckinCodeListResponse {
  ttlMinutes: number;
  codes: VisitorCheckinCodeView[];
}

export async function listVisitorCheckinCodes(): Promise<VisitorCheckinCodeListResponse> {
  return await agent.requests.get('/api/company/visitor-checkin/codes');
}

export async function generateVisitorCheckinCode(officeId: number, label: string | null, deviceType: PairedDeviceType = 'KIOSK'): Promise<VisitorCheckinCodeView> {
  return await agent.requests.post('/api/company/visitor-checkin/codes', { officeId, label, deviceType });
}

export async function revokeVisitorCheckinCode(id: number): Promise<void> {
  await agent.requests.del(`/api/company/visitor-checkin/codes/${id}`);
}

export async function updateVisitorCheckinTtl(ttlMinutes: number | null): Promise<VisitorCheckinCodeListResponse> {
  return await agent.requests.put('/api/company/visitor-checkin/ttl', { ttlMinutes });
}

export interface VisitorCheckinPendingRequestView {
  requestId: string;
  code: string;
  officeId: number;
  officeLabel: string;
  label: string | null;
  createdAt: string;
  expiresAt: string;
  clientIp: string | null;
  deviceType: PairedDeviceType;
}

export async function listVisitorCheckinPendingRequests(): Promise<VisitorCheckinPendingRequestView[]> {
  return await agent.requests.get('/api/company/visitor-checkin/pending-requests');
}

export async function approveVisitorCheckinPendingRequest(requestId: string): Promise<VisitorCheckinPendingRequestView> {
  return await agent.requests.post(`/api/company/visitor-checkin/pending-requests/${encodeURIComponent(requestId)}/approve`, {});
}

export async function rejectVisitorCheckinPendingRequest(requestId: string): Promise<VisitorCheckinPendingRequestView> {
  return await agent.requests.post(`/api/company/visitor-checkin/pending-requests/${encodeURIComponent(requestId)}/reject`, {});
}
